let defaults = {};

defaults.images = JSON.parse(capAlgolia.default_images);

export default defaults;